export const messages = {
  title: {
    id: 'admin/promotions.form.sellers.title',
  },
  applyTo: {
    id: 'admin/promotions.form.sellers.operator',
  },
  mainSellerHelpText: {
    id: 'admin/promotions.form.sellers.whitelabel-warning',
  },
  label: {
    id: 'admin/promotions.form.sellers.selector.label',
  },
  options: {
    all: {
      id: 'admin/promotions.form.sellers.all',
    },
    equals: {
      id: 'admin/promotions.form.sellers.equals',
    },
    different: {
      id: 'admin/promotions.form.sellers.different',
    },
    optIn: {
      id: 'admin/promotions.form.sellers.opt-in',
    },
  },
}
